import apiFetch from './client';

export function getWorkouts(filters = {}) {
  const params = new URLSearchParams();
  if (filters.tag_id) params.append('tag_id', filters.tag_id);
  if (filters.format_type) params.append('format_type', filters.format_type);
  if (filters.difficulty) params.append('difficulty', filters.difficulty);
  if (filters.published_only) params.append('published_only', 'true');
  const qs = params.toString();
  return apiFetch(`/api/workouts/${qs ? '?' + qs : ''}`);
}

export function getWorkout(id) {
  return apiFetch(`/api/workouts/${id}`);
}

export function createWorkout(data) {
  return apiFetch('/api/workouts/', { method: 'POST', body: JSON.stringify(data) });
}

export function updateWorkout(id, data) {
  return apiFetch(`/api/workouts/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export function deleteWorkout(id) {
  return apiFetch(`/api/workouts/${id}`, { method: 'DELETE' });
}

export function cloneWorkout(id) {
  return apiFetch(`/api/workouts/${id}/clone`, { method: 'POST' });
}

export function publishWorkout(id, published) {
  return apiFetch(`/api/workouts/${id}/publish`, {
    method: 'PUT',
    body: JSON.stringify(published),
  });
}

export function importWorkout(id) {
  return apiFetch(`/api/workouts/${id}/import`, { method: 'POST' });
}
